export default function AuthHeader() {
    const token = JSON.parse(localStorage.getItem('token')); 
    //console.log(token)
    if (token && token.access_token) {
      return { Authorization: 'Bearer ' + token.access_token };
    } else {
      return {};
    }
  }